import { SelectFieldOption } from "../../beta/components/SelectField/types";
import { CSSProperties, forwardRef, useCallback } from "react";
import { CheckState } from "../../types";
import { OptionsPanel, OptionsPanelHandle } from "./OptionsPanel";
import { VirtualizedOptionsPanel } from "./VirtualizedOptionsPanel";
import {
  GetItemPropsFn,
  GetMenuPropsFn,
  SectionMeta,
  SelectItem,
} from "../types/selectFieldInternalTypes";

export type SelectOptionsProps = {
  isOpen: boolean;
  items: SelectItem[];
  getMenuProps: GetMenuPropsFn;
  getItemProps: GetItemPropsFn;
  highlightedIndex: number;
  selectedOption: SelectFieldOption | null;
  hasMore: boolean;
  onLoadMore: () => void;
  loading: boolean;
  loadingMore: boolean;
  disableAutoLoadMore?: boolean;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  sectionsMeta?: SectionMeta[];
  virtualize?: boolean;
};

export const SelectOptions = forwardRef<OptionsPanelHandle, SelectOptionsProps>(
  ({ selectedOption, virtualize, ...rest }, ref) => {
    const getCheckedState = useCallback(
      (item: SelectItem): CheckState =>
        selectedOption?.id === item.original.id ? "checked" : "unchecked",
      [selectedOption],
    );

    const ListComponent = virtualize ? VirtualizedOptionsPanel : OptionsPanel;

    return (
      <ListComponent
        {...rest}
        ref={ref}
        selectionType="single"
        getCheckedState={getCheckedState}
      />
    );
  },
);

SelectOptions.displayName = "SelectOptions";
